var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('progress',{staticClass:"programProgress",attrs:{"max":_vm.max},domProps:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }